export const buildSminexClubClientsByEventSubscription = (eventId: number, segment = 'CB') => `
  subscription getSminexClubClients {
    getSminexClubClients(
        input: {eventId: ${eventId}, segment: ${segment}}
    ) {
      data {
        participant {
          crmUuid
          firstName
          lastName
          surname
          projects
          manager
          broker
          callRefusal
          tickets {
            id
            checked
            checkInTime
            scanType
            organizerName
            sminexClubReconfirmationStatus
            sminexClubInvitation
            review
            comment
            invitedByManager
            sminexClubAdditional
            mobileComment
            isSpecial
            participant {
              id
            }
            dependents {
              adult {
                id
                checked
                participant {
                  firstName
                  lastName
                  surname
                }
              }
            }
          }
        }
      }
    }
  }
`;

export interface SminexClubClientsByEventTicketParticipant {
  id?: number | null;
}

interface TicketDependents {
  adult: {
    id: number;
    checked: boolean;
    participant: {
      firstName?: string | null;
      lastName?: string | null;
      surname?: string | null;
    };
  }[];
}

export interface SminexClubClientsByEventTicket {
  id?: number | null;
  checked?: boolean | null;
  checkInTime?: string | null;
  scanType?: string | null;
  organizerName?: string | null;
  sminexClubInvitation?: string | null;
  sminexClubReconfirmationStatus?: string | null;
  review?: string | null;
  comment?: string | null;
  sminexClubAdditional?: string | null;
  invitedByManager?: string | null;
  participant?: SminexClubClientsByEventTicketParticipant | null;
  mobileComment?: string | null;
  isSpecial?: boolean | null;
  dependents?: TicketDependents | null;
}

export interface SminexClubClientsByEventParticipant {
  crmUuid?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  surname?: string | null;
  projects?: Array<string | null> | null;
  manager?: string | null;
  broker?: string | null;
  callRefusal?: boolean | null;
  tickets: SminexClubClientsByEventTicket;
}

export interface SminexClubClientsByEventPayload {
  getSminexClubClients?: {
    data?: Array<{ participant?: SminexClubClientsByEventParticipant | null } | null> | null;
  } | null;
}
